import { render, staticRenderFns } from "./SuiteReservation.vue?vue&type=template&id=1a79ddce&scoped=true&"
import script from "./SuiteReservation.vue?vue&type=script&lang=js&"
export * from "./SuiteReservation.vue?vue&type=script&lang=js&"
import style0 from "./SuiteReservation.vue?vue&type=style&index=0&id=1a79ddce&prod&lang=scss&scoped=true&"
import style1 from "./SuiteReservation.vue?vue&type=style&index=1&id=1a79ddce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a79ddce",
  null
  
)

export default component.exports